/** Client custom pricing templates (Mongo) — translate known catalog entries for i18n. */
function foldKey(s) {
  return String(s)
    .trim()
    .normalize('NFD')
    .replace(/\u0300-\u036f/g, '')
    .toLowerCase();
}

const CLIDRIVE_NAME_KEYS = new Set(['tarifa clidrive', 'clidrive rate']);

const CLIDRIVE_DESC_KEYS = new Set([
  foldKey('Tarifas especiales para Clidrive'),
  foldKey('Tarifa especial negociada para Grupo Clidrive'),
  foldKey('Special rates for Clidrive'),
  foldKey('Negotiated rate for Grupo Clidrive'),
]);

export function translateClientCustomTemplateName(name, t) {
  if (!name) return '';
  if (CLIDRIVE_NAME_KEYS.has(foldKey(name))) return t('admin_template_clidrive_name');
  return name;
}

export function translateClientCustomTemplateDescription(description, t) {
  if (!description) return '';
  if (CLIDRIVE_DESC_KEYS.has(foldKey(description))) {
    return t('admin_template_clidrive_description');
  }
  return description;
}
